module.exports = __webpack_public_path__ + "img/IMG_1699_WoodMatted_MockedUp.20e99df6.jpg";